<template>
  <el-dialog
    :title="$t('importFromExcel')"
    :visible.sync="dialogVisible"
    width="900px"
    class="upload-extended-attribute"
  >
    <el-steps :active="active" finish-status="success" simple class="mt-20px">
      <el-step class="fz-14" :title="`${$t('downloadTemplete')}`"></el-step>
      <el-step :title="`${$t('uploadFile')}`"></el-step>
      <el-step :title="`${$t('complete')}`"></el-step>
    </el-steps>
    <div v-show="active === 1">
      <div class="text-center pt-30px">
        <div class="upload-demo">
          <div class="el-upload el-upload--text down-text">
            <div class="el-upload-dragger">
              <i
                @click="downloadTemplate"
                class="icon iconfont icon-bg-excel main-color"
                style="height: 100px; font-size: 70px"
              ></i>
              <div class="el-upload__text">
                {{ $t('clickDownloadTemplete') }}
                <em class="text-color" @click="nextStep">{{ $t('nextStep') }}</em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="active === 2" class="text-center">
      <el-upload
        v-loading="loading"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="false"
        :before-upload="getFileContent"
        :http-request="uploadExcel"
        :multiple="false"
      >
        <i style="font-size: 67px" class="iconfont icon-bg-upload main-color"></i>
        <div class="el-upload__text">
          {{ $t('onlyOne') }}
          <em>{{ $t('clickUpload') }}</em>
        </div>
      </el-upload>
    </div>
    <div class="padding-1" v-show="active === 3">
      <div style="text-align: center">
        <div class="upload-demo">
          <div class="el-upload el-upload--text down-text">
            <div class="el-upload-dragger pt-20px">
              <!-- <span class="mt-30px">
                  <i
                    class="iconfont icon-bg-download main-color"
                    style="font-size: 54px"
                    @click="downResultFile"
                  ></i>
                </span> -->
              <!-- <div class="el-upload__text" v-if="resultFile">{{ $t('downloadUploadResult') }}</div> -->
              <div class="el-upload__text">{{ $t('uploadSuccess') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="closeDialog" v-if="active !== 3" :loading="loading">
        {{ $t('cancel') }}
      </el-button>
      <el-button v-if="active === 2" type="primary" @click="active = 1" :loading="loading">
        {{ $t('previous') }}
      </el-button>
      <el-button v-if="active === 3" type="primary" @click="handleConfirm" :loading="loading">
        {{ $t('complete') }}
      </el-button>
      <el-button v-if="active === 1" type="primary" @click="nextStep" :loading="loading">
        {{ $t('nextStep') }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { active } from 'sortablejs'
import fnMixin from '@/assets/js/fnMixins'
import stdClassListService from '../../../../../services/stdClassListService'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    attributeId: {
      type: String,
      default: '',
    },
  },
  mixins: [fnMixin],
  data() {
    return {
      loading: false,
      file: null,
      active: 1,
      resultList: [],
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
    },
    // 下载模板
    async downloadTemplate() {
      const res = await stdClassListService.downloadExtendedTemplate()
      this.downLoadExcel('拓展属性导入模板', res)
    },
    // 下一步
    nextStep() {
      this.active += 1
      if (this.active > 2) {
        this.active = 1
      }
    },
    // 上传
    async uploadExcel() {
      this.loading = true
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('attributeId', this.attributeId)
      const res = await stdClassListService.importExtended(formData)
      this.loading = false
      if (res.code == 0) {
        this.resultList = res.data
        this.active = 3
      } else {
        this.$message.error(res.msg)
      }
    },
    getFileContent(file) {
      this.file = file
    },
    handleConfirm() {
      const result = this.resultList.map((item) => {
        return {
          extendClassId: item.classId,
          flag: item.flag,
          extendClassCode: item.classCode,
          stdClassExtendAttributeDtos: [
            {
              displayName: item.displayName,
              extendClassAttributeId: item.attributeId,
              extendClassAttributeName: item.attributeName,
            },
          ],
        }
      })
      this.$emit('confirm', result)
      this.closeDialog()
    },
  },
}
</script>
<style lang="scss" scoped>

.iconfont {
  &.icon-d-excel {
    font-size: 70px !important;
  }
  &.icon-download {
    font-size: 54px !important;
  }
}
/deep/.el-upload-dragger {
  margin-top: 25px;
}
/deep/.el-step.is-simple /deep/.el-step__title {
  font-size: 15px !important;
}
.main-color {
  color: var(--systemMainColor);
}

</style>
